export const S3_ASSETS = {
  CHAT_PREVIEW_PLACEHOLDER: {
    url: 'https://messenger-assets-public.s3.ap-southeast-1.amazonaws.com/portal-client/chat_preview_placeholder.png',
  },
};
